import * as MessageActions from '../../common/messageBox/actions/actions';
import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const fetchQualityControlInvoicing = (order) =>
  apiActionCreator({
    'endpoint': `/quality-assurance/invoicing/orders/${order}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_QUALITY_CONTROL_INVOICING,
      ActionTypes.FETCHED_QUALITY_CONTROL_INVOICING,
      [
        ActionTypes.FETCHED_QUALITY_CONTROL_INVOICING_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const createQualityControlInvoice =
  (order, data = {}) =>
    (dispatch) => {
      return dispatch(
        apiActionCreator({
          'endpoint': `/quality-assurance/invoicing/orders/${order}`,
          'authenticated': true,
          'types': [
            ActionTypes.CREATING_QUALITY_CONTROL_INVOICE,
            [
              () => {
                dispatch(fetchQualityControlInvoicing(order));
                return {
                  'type': ActionTypes.CREATED_QUALITY_CONTROL_INVOICE,
                };
              },
              (response) =>
                MessageActions.addMessageBoxInfo(response.data.message),
            ],
            [
              ActionTypes.CREATED_QUALITY_CONTROL_INVOICE_FAILED,
              (error) => buildErrorMessage(error),
            ],
          ],

          'microservice': 'part',
          'method': 'POST',
          'contentType': 'application/json',
          data,
        })
      );
    };
